import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CounterAppSeqType } from '../../../../_models';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-text-two-decimal-number-renderer',
    templateUrl: './text-two-decimal-number-renderer.component.html',
    standalone: false
})
export class TextTwoDecimalNumberRendererComponent implements ICellRendererAngularComp {
  errReq: boolean = false;
  value: string;
  params: ICellRendererParams;
  isMandatory:boolean=false;
  isEnd:boolean=false;
  isVisible : boolean = false;
  placeholdertext: string = this.translate.instant('enter_amount_set_limit');

  constructor(private translate: TranslateService)
  {

  }


  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.params = params;
      if(Number(params.data.allowanceRate)>0)
            this.value = params.data.allowanceRate;
      if(Number(params.data.invoiceCALimit)>0 && params.colDef.headerComponentParams 
      && params.colDef.headerComponentParams.fromVendor)
      {
        this.value = params.data.invoiceCALimit;
      }
      if(Number(params.data.caLimit)>0 && params.colDef.headerComponentParams 
      && !params.colDef.headerComponentParams.fromVendor)
      {
        this.value = params.data.caLimit;
      }
                  
      if(Number(params.data.carbonFootprint) > 0)
            this.value = params.data.carbonFootprint;     
          
      if(Number(params.data.carbonFootprint) <= 0)
      {    
        this.placeholdertext = this.translate.instant('enter_cev');              
      }
            
      if(Number(this.value)>0)
           this.placeholdertext = '';

      this.isMandatory = params.data.sequence == CounterAppSeqType.Mandatory ;
      this.isEnd = params.data.sequence == CounterAppSeqType.End;
      // Opt-in via the column's headerComponentParams (set only on the Counter Approver amount
      // columns): show the red border while the row has no valid amount, so a newly added empty
      // row reads as "needs a value". Other grids using this renderer are unaffected.
      const requiredOnEmpty = !!(params.colDef.headerComponentParams && params.colDef.headerComponentParams.requiredOnEmpty);
      this.errReq = ((this.value == '' || Number(this.value) <= 0) || params.data.errorRecord || (requiredOnEmpty && !(Number(this.value) > 0))) ? true : false;
      if(this.errReq)
      {
        this.value = '';
        // For a required-on-empty column keep the field's own prompt (e.g. "Enter amount to set
        // limit"); switch to "Required" only when a validation error has actually been recorded.
        if(params.data.errorRecord || !requiredOnEmpty)
        {
          this.placeholdertext = this.translate.instant('label_Required');
        }
      }

    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

  onMouseDown(event) {
    // Keep the click inside the input: stop ag-grid from handling it for
    // row selection / cell focus, which otherwise breaks in-cell editing.
    event.stopPropagation();
    // On the first click (input not yet focused) select the whole value so the
    // user can immediately retype; a second click places the caret to edit part.
    if (document.activeElement !== event.target) {
      event.preventDefault();
      event.target.focus();
    }
  }

  onChange(event) {
   
    if(event.target.value && event.target.value != ''){
      this.value = parseFloat(event.target.value).toFixed(2);
    }
    else{
      this.value = event.target.value;
    }
    this.errReq = (this.value == '' || Number(this.value) <= 0) ? true : false;
    this.params.setValue(this.value);
    this.params.node.setData(this.params.data);
    this.params.eGridCell.click();
  }

}
